import React, { forwardRef } from 'react';
import {
  IconArrowsExchange,
  IconArrowsShuffle,
  IconArrowsVertical,
  IconBattery4,
  IconBook,
  IconBookmark,
  IconBrandGoogle,
  IconCirclePlus,
  IconCircleX,
  IconCloudUpload,
  IconCode,
  IconCompass,
  IconDatabase,
  IconDeviceMobile,
  IconFilter,
  IconFlag,
  IconFlagCheck,
  IconHandFinger,
  IconInfinity,
  IconLanguage,
  IconMail,
  IconMusic,
  IconPercentage,
  IconPhone,
  IconPlug,
  IconRadio,
  IconRipple,
  IconRulerMeasure2,
  IconServer,
  IconSitemap,
  IconStopwatch,
  IconToiletPaper,
  IconToolsKitchen2,
  IconTruckDelivery,
  IconUserCircle,
  IconUsers,
  IconWifi,
  IconZoomIn,
  IconAdjustmentsHorizontal,
  IconArchive,
  IconArrowForwardUp,
  IconArrowsMinimize,
  IconArrowsMove,
  IconArrowsSort,
  IconBan,
  IconBath,
  IconBinoculars,
  IconBoxMultiple,
  IconBrush,
  IconBuilding,
  IconCheckbox,
  IconChevronsLeft,
  IconChevronsRight,
  IconChristmasTree,
  IconCircle,
  IconCloudDownload,
  IconColumns,
  IconCreditCard,
  IconCrop,
  IconDots,
  IconDotsVertical,
  IconEraser,
  IconFirstAidKit,
  IconLayoutBottombar,
  IconLifebuoy,
  IconListCheck,
  IconListNumbers,
  IconPlayerPlay,
  IconPointer,
  IconSquare,
  IconTag,
  IconTypography,
  IconUnlink,
  IconUpload,
  IconUser,
  IconAlertCircle,
  IconAlertTriangle,
  IconAnchor,
  IconArrowBackUp,
  IconArrowDown,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconArrowUpRight,
  IconArrowsHorizontal,
  IconArrowsMaximize,
  IconBell,
  IconBolt,
  IconBus,
  IconCalendar,
  IconCalendarCheck,
  IconCalendarX,
  IconCar,
  IconChartAreaLine,
  IconChartBar,
  IconChartLine,
  IconCheck,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconCircleCheck,
  IconClipboard,
  IconClock,
  IconCloud,
  IconCloudRain,
  IconCloudSnow,
  IconCopy,
  IconCrosshair,
  IconCurrencyDollar,
  IconDashboard,
  IconDeviceFloppy,
  IconDownload,
  IconDroplet,
  IconEdit,
  IconExclamationMark,
  IconExternalLink,
  IconEye,
  IconEyeOff,
  IconFile,
  IconFileText,
  IconFileTypeJpg,
  IconFileTypePdf,
  IconFileZip,
  IconFolderOpen,
  IconGauge,
  IconGridDots,
  IconHelpCircle,
  IconHistory,
  IconHome,
  IconHourglass,
  IconInfoCircle,
  IconKey,
  IconLayoutGrid,
  IconLibraryPhoto,
  IconLink,
  IconList,
  IconListDetails,
  IconLoader2,
  IconLock,
  IconLogin,
  IconLogout,
  IconMap,
  IconMapPin,
  IconMenu2,
  IconMinus,
  IconMist,
  IconMoon,
  IconNavigation,
  IconNote,
  IconPencil,
  IconPhoto,
  IconPin,
  IconPlane,
  IconPlayerStop,
  IconPlus,
  IconPrinter,
  IconQrcode,
  IconQuote,
  IconRefresh,
  IconRoad,
  IconSearch,
  IconSend,
  IconSettings,
  IconShare,
  IconShield,
  IconSignRight,
  IconSnowflake,
  IconStar,
  IconSun,
  IconTemperature,
  IconTemperatureMinus,
  IconTemperaturePlus,
  IconTrash,
  IconVideo,
  IconWalk,
  IconWand,
  IconSparkles,
  IconWind,
  IconWorld,
  IconX
} from '@tabler/icons-react';
import { maritimeIcons } from './MaritimeIcon';

// Explicit imports keep the bundle tree-shakeable. These aliases cover the two
// app screens and the icon names supplied by their domain-data helpers.
export const appIcons = {
  ...maritimeIcons,
  'clock': IconClock,
  'folder open': IconFolderOpen,
  'users': IconUsers,
  'compass': IconCompass,
  'arrows alternate vertical': IconArrowsVertical,
  'warning': IconAlertTriangle,
  'database': IconDatabase,
  'user circle': IconUserCircle,
  'world': IconWorld,
  'long arrow alternate down': IconArrowDown,
  'flag': IconFlag,
  'infinity': IconInfinity,
  'wifi': IconWifi,
  'plug': IconPlug,
  'star': IconStar,
  'user': IconUser,
  'book': IconBook,
  'map marker': IconMapPin,
  'list ul': IconList,
  'flag checkered': IconFlagCheck,
  'mobile alternate': IconDeviceMobile,
  'compass outline': IconCompass,
  'paper plane outline': IconSend,
  'file alternate': IconFileText,
  'file text outline': IconFileText,
  'music': IconMusic,
  'cloud upload': IconCloudUpload,
  'random': IconArrowsShuffle,
  'long arrow alternate right': IconArrowRight,
  'hand pointer outline': IconHandFinger,
  'time': IconClock,
  'sitemap': IconSitemap,
  'food': IconToolsKitchen2,
  'calendar alternate': IconCalendar,
  'mail': IconMail,
  'search plus': IconZoomIn,
  'phone': IconPhone,
  'radio': IconRadio,
  'sticky note': IconNote,
  'share square': IconShare,
  'stopwatch': IconStopwatch,
  'point': IconMapPin,
  'filter': IconFilter,
  'calendar outline': IconCalendar,
  'sign in': IconLogin,
  'sign out': IconLogout,
  'envelope outline': IconMail,
  'google': IconBrandGoogle,
  'plus circle': IconCirclePlus,
  'bookmark': IconBookmark,
  'water': IconRipple,
  'ruler-measure-2': IconRulerMeasure2,
  'calendar check': IconCalendarCheck,
  'exchange': IconArrowsExchange,
  'battery full': IconBattery4,
  'send': IconSend,
  'shipping fast': IconTruckDelivery,
  'times circle': IconCircleX,
  'percent': IconPercentage,
  'code': IconCode,
  'server': IconServer,
  'language': IconLanguage,
  'unlink': IconUnlink,
  'atm': IconCreditCard,
  'pharmacy': IconFirstAidKit,
  'toilets': IconToiletPaper,
  'touristInfo': IconInfoCircle,

  'add': IconPlus,
  'angle double left': IconChevronsLeft,
  'angle double right': IconChevronsRight,
  'angle left': IconChevronLeft,
  'angle right': IconChevronRight,
  'archive': IconArchive,
  'arrows alternate': IconArrowsMove,
  'ban': IconBan,
  'building': IconBuilding,
  'check square': IconCheckbox,
  'circle': IconCircle,
  'circle outline': IconCircle,
  'clone outline': IconCopy,
  'cloud download': IconCloudDownload,
  'columns': IconColumns,
  'compress': IconArrowsMinimize,
  'crop': IconCrop,
  'ellipsis horizontal': IconDots,
  'ellipsis vertical': IconDotsVertical,
  'erase': IconEraser,
  'expand': IconArrowsMaximize,
  'file outline': IconFile,
  'font': IconTypography,
  'image outline': IconPhoto,
  'life ring outline': IconLifebuoy,
  'list ol': IconListNumbers,
  'magic': IconWand,
  'sparkles': IconSparkles,
  'mouse pointer': IconPointer,
  'object group outline': IconBoxMultiple,
  'paint brush': IconBrush,
  'pin': IconPin,
  'play': IconPlayerPlay,
  'redo': IconArrowForwardUp,
  'sliders horizontal': IconAdjustmentsHorizontal,
  'sort': IconArrowsSort,
  'square outline': IconSquare,
  'stop': IconPlayerStop,
  'stop circle': IconPlayerStop,
  'tag': IconTag,
  'tasks': IconListCheck,
  'tree': IconChristmasTree,
  'unlinkify': IconUnlink,
  'upload': IconUpload,
  'user outline': IconUser,
  'window maximize outline': IconLayoutBottombar,
  'credit card outline': IconCreditCard,
  'bath': IconBath,
  'medkit': IconFirstAidKit,
  'binoculars': IconBinoculars,
  'info': IconInfoCircle,

  'anchor': IconAnchor,
  'area graph': IconChartAreaLine,
  'arrow down': IconArrowDown,
  'arrow left': IconArrowLeft,
  'arrow right': IconArrowRight,
  'arrow up': IconArrowUp,
  'arrows alternate horizontal': IconArrowsHorizontal,
  'bars': IconMenu2,
  'bell': IconBell,
  'bell outline': IconBell,
  'blind': IconWalk,
  'bolt': IconBolt,
  'bus': IconBus,
  'calendar': IconCalendar,
  'calendar alternate outline': IconCalendar,
  'calendar check outline': IconCalendarCheck,
  'calendar times outline': IconCalendarX,
  'cancel': IconX,
  'car': IconCar,
  'chart bar': IconChartBar,
  'chart line': IconChartLine,
  'check': IconCheck,
  'check circle': IconCircleCheck,
  'check circle outline': IconCircleCheck,
  'checkmark': IconCheck,
  'chevron down': IconChevronDown,
  'chevron left': IconChevronLeft,
  'chevron right': IconChevronRight,
  'chevron up': IconChevronUp,
  'circle notched': IconLoader2,
  'clipboard outline': IconClipboard,
  'clock outline': IconClock,
  'close': IconX,
  'cloud': IconCloud,
  'cloud meatball': IconCloudSnow,
  'cloud rain': IconCloudRain,
  'cloud showers heavy': IconCloudRain,
  'cloud sun': IconCloud,
  'cloudversify': IconCloud,
  'copy': IconCopy,
  'copy outline': IconCopy,
  'crosshairs': IconCrosshair,
  'dashboard': IconDashboard,
  'dollar': IconCurrencyDollar,
  'dollar sign': IconCurrencyDollar,
  'download': IconDownload,
  'dropdown': IconChevronDown,
  'edit': IconEdit,
  'exclamation': IconExclamationMark,
  'exclamation circle': IconAlertCircle,
  'exclamation triangle': IconAlertTriangle,
  'expand arrows alternate': IconArrowsMaximize,
  'external': IconExternalLink,
  'external alternate': IconExternalLink,
  'eye': IconEye,
  'eye slash': IconEyeOff,
  'file': IconFile,
  'file alternate outline': IconFileText,
  'file archive outline': IconFileZip,
  'file image': IconFileTypeJpg,
  'file image outline': IconFileTypeJpg,
  'file pdf': IconFileTypePdf,
  'file pdf outline': IconFileTypePdf,
  'file text': IconFileText,
  'folder open outline': IconFolderOpen,
  'globe': IconWorld,
  'grid layout': IconLayoutGrid,
  'history': IconHistory,
  'home': IconHome,
  'hourglass half': IconHourglass,
  'image': IconPhoto,
  'images outline': IconLibraryPhoto,
  'info circle': IconInfoCircle,
  'key': IconKey,
  'level up alternate': IconArrowUpRight,
  'line graph': IconChartLine,
  'linkify': IconLink,
  'list': IconList,
  'list alternate outline': IconListDetails,
  'location arrow': IconNavigation,
  'lock': maritimeIcons['ship in lock'],
  'padlock': IconLock,
  'map': IconMap,
  'map marker alternate': IconMapPin,
  'map outline': IconMap,
  'map pin': IconPin,
  'map signs': IconSignRight,
  'minus': IconMinus,
  'moon': IconMoon,
  'paper plane': IconSend,
  'pencil': IconPencil,
  'plane': IconPlane,
  'plus': IconPlus,
  'print': IconPrinter,
  'qrcode': IconQrcode,
  'question circle': IconHelpCircle,
  'question circle outline': IconHelpCircle,
  'quote left': IconQuote,
  'rain': IconCloudRain,
  'refresh': IconRefresh,
  'road': IconRoad,
  'save': IconDeviceFloppy,
  'search': IconSearch,
  'setting': IconSettings,
  'settings': IconSettings,
  'share alternate': IconShare,
  'shield alternate': IconShield,
  'ship': maritimeIcons['ship only'],
  'sign-in': IconLogin,
  'sign-out': IconLogout,
  'smog': IconMist,
  'snowflake': IconSnowflake,
  'snowflake outline': IconSnowflake,
  'spinner': IconLoader2,
  'star outline': IconStar,
  'sticky note outline': IconNote,
  'stop circle outline': IconPlayerStop,
  'sun': IconSun,
  'sun outline': IconSun,
  'sync': IconRefresh,
  'tachometer alternate': IconGauge,
  'th': IconGridDots,
  'thermometer empty': IconTemperatureMinus,
  'thermometer full': IconTemperaturePlus,
  'thermometer half': IconTemperature,
  'times': IconX,
  'tint': IconDroplet,
  'trash': IconTrash,
  'trash alternate outline': IconTrash,
  'undo': IconArrowBackUp,
  'video': IconVideo,
  'warning circle': IconAlertCircle,
  'warning sign': IconAlertTriangle,
  'wind': IconWind,
  'wizard': IconWand,
};

export const AppIcon = forwardRef(function AppIcon({ name, size, loading, corner, color, verticalAlign, title, style, className = '', ...props }, ref) {
  if (!name) return null;
  const Component = appIcons[name] || IconHelpCircle;
  const pixels = { mini: 12, tiny: 14, small: 16, large: 22, big: 32, huge: 40 }[size] || size || 18;
  const accessible = Boolean(title || props['aria-label']);
  return <Component ref={ref} size={pixels} stroke={1.8} role={accessible ? 'img' : undefined}
    aria-hidden={accessible ? undefined : true} focusable="false" {...props}
    className={`tour-icon ${loading ? 'tour-icon-spin' : ''} ${corner ? 'tour-icon-corner' : ''} ${className}`}
    style={{ verticalAlign: verticalAlign || 'middle', color: color ? `var(--mantine-color-${color === 'grey' ? 'gray' : color}-6, ${color})` : undefined, ...style }}>
    {title && <title>{title}</title>}
  </Component>;
});
